import { Stack, styled } from "@mui/material";

export const DisbursedLoanReportWrapper = styled(Stack)(({ theme }) => {
	return {
		gap: "var(--flex-gap)",
		overflow: "hidden",
		"& .filter-bar": {
			padding: "var(--basic-padding)",
			backgroundColor: "var(--light-color)",
			borderRadius: "16px",
			display: "flex",
			gap: "var(--flex-gap)",
			justifyContent: "space-between",
			alignItems: "flex-start",
			[theme.breakpoints.down("laptop")]: {
				flexDirection: "column",
				alignItems: "stretch",
			},
		},
		"& fieldset": {
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between",
			overflow: "hidden",
			flex: 1,
		},
		"& .disbursed-loan-report-table-box": {
			"& .MuiTableContainer-root": {
				borderRadius: "16px",
				"& .MuiTableHead-root": {
					"& .MuiTableCell-root": {
						minWidth: "250px",
						whiteSpace: "normal",
					},
				},
			},
		},
		"& .call-to-action-stack": {
			overflow: "hidden",
			gap: "calc(var(--basic-margin)/4)",
			"& .dropdown-modal": {
				backgroundColor: "var(--light-color)",
				zIndex: 1,
				borderRadius: "8px",
				paddingTop: 0,
				paddingBottom: 0,
				overflow: "hidden",
				maxWidth: "80px",
				"& .MuiListItem-root": {
					padding: 0,
					"& .MuiListItemText-root": {
						fontSize: "16px",
					},
					"&:hover": {
						backgroundColor: "var(--diluted-primary-color)",
					},
				},
			},
		},
	};
});
